export const routes = (prefix, pre) => [
    {
        name: `${prefix}.${pre}.invoices-per-visit-report.index`,
        path: `/${prefix}/${pre}/invoices-per-visit-report`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.${pre}.invoices-per-visit-report.index`,
                PageDescription: "Accounts/Finance Reports: Invoices per visit report",
            },
        },
    },
    {
        name: `${prefix}.${pre}.prints.invoices-per-visit-report.index`,
        path: `/${prefix}/${pre}/invoices-per-visit-report/print`,
        component: () => import('./prints/InvoicePerVisitReport.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.${pre}.invoices-per-visit-report.index`,
                PageDescription: "Accounts/Finance Reports: Invoices per visit report",
            },
            print: true,
        },
    },
    {
        name: `${prefix}.${pre}.prints.invoices-per-visit-details.index`,
        path: `/${prefix}/${pre}/invoices-per-visit-details/print`,
        component: () => import('./prints/InvoiceDetails.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.${pre}.invoices-per-visit-report.index`,
                PageDescription: "Accounts/Finance Reports: Invoices per visit report",
            },
            print: true,
        },
    },
];